import styled from 'styled-components';

export const WrapperContentHomePage = styled.div`
  position: relative;
  @media (min-width: 318px) and (max-width: 576px) {
    width: 100%;
  }
`;
